export default "__VITE_ASSET__R8j10X4j__"